const NS = 'SiteAnnouncementWidget';
const CLS = 'siteAnnouncementWidget';

export class SiteAnnouncementWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$btnClose = this.$element.find(`.${CLS}-btn--close`);
		this.toggleAnimationDuration = 400;

		this.assignDataClosedAttribute();

		this.$btnClose.on('click', () => {
			this.close();
		});
	}

	assignDataClosedAttribute() {
		this.$element.attr('data-closed', false);
	}

	close() {
		this.$element.attr('data-closed', true);
		this.$element.css('height', 0);
		$('.siteHeaderMenuWidget').css('top', 100);
		$('.siteHeaderSearchBarWidget').css('top', 100);
	}
}
